import { Step } from '../../../../../views/alerts/PendingOrderAlertScreen';
import { BackendErrorCode, OrderMethod } from '../../../../../services/exports/Constants';

export default {
  steps: {
    [Step.OrderPreview]: {
      titles: {
        asap: 'Novo pedido {{method}}!',
        scheduled: 'Pedido {{method}} agendado!',
        on_site: 'Novo pedido à mesa!',
        // Table orders are ASAP; this is for room-service orders scheduled before the rename.
        on_site_scheduled: 'Encomenda agendada para a mesa!',
      },
      labels: {
        today: 'hoje',
        time_remaining_to_accept: 'restantes para aceitar',
      },
      time_tag: {
        [OrderMethod.Pickup]: {
          asap: '🕓 Recolha em {{time}}',
          scheduled: '🕓 Recolha {{day}} às {{time}}',
          scheduled_today: '🕓 Recolha hoje às {{time}}',
        },
        [OrderMethod.Delivery]: {
          asap: '🕓 Entrega em {{time}}',
          scheduled: '🕓 Entrega {{day}} às {{time}}',
          scheduled_today: '🕓 Entrega hoje às {{time}}',
        },
        [OrderMethod.OnSite]: {
          // No 🕓: the screen draws the design's clock icon for table orders.
          asap: 'Servir em {{from}}–{{to}} min',
          scheduled: 'Servir {{day}} às {{time}}',
          scheduled_today: 'Servir hoje às {{time}}',
        },
      },
      time_tag_estimated: {
        asap: '🕓 Estimativa de recolha: {{time}}',
        scheduled: '🕓 Estimativa de recolha: {{day}} às {{time}}',
      },
      buttons: {
        confirm_order: 'Confirmar pedido',
        cancel_order: 'Cancelar pedido',
      },
      feedback: {
        rough_estimate_warning:
          'Esta é apenas uma estimativa aproximada. Receberá o tempo de preparação real quando um estafeta for atribuído e o tempo de entrega confirmado. Nesse momento, o talão será impresso automaticamente.',
      },
    },
    [Step.OrderConfirmation]: {
      title: 'Tempo de preparação',
      labels: {
        today: 'hoje',
        order_time: {
          [OrderMethod.Delivery]: {
            asap: 'Entrega em',
            scheduled: 'Entrega a',
            scheduled_today: 'Entrega',
          },
          [OrderMethod.Pickup]: {
            asap: 'Recolha em',
            scheduled: 'Recolha a',
            scheduled_today: 'Recolha',
          },
          [OrderMethod.OnSite]: {
            asap: 'Servir em',
            scheduled: 'Servir a',
            scheduled_today: 'Servir',
          },
        },
        can_you_make_it: 'Consegue cumprir?',
        we_also_send_this_update_to_the_customer: 'Enviamos também esta atualização ao cliente',
      },
      buttons: {
        yes_lets_go: 'Sim, vamos!',
        no_change_time: 'Não, alterar hora',
        confirm: 'Confirmar',
      },
      toasts: {
        order_confirmed: {
          title: 'Pedido #{{number}} confirmado',
          body: 'Não prepare ainda! Avisaremos quando um estafeta for atribuído.',
        },
        [BackendErrorCode.NoDeliveryQuotesAvailable]:
          'Infelizmente, a entrega tem de ser cancelada porque o estafeta não está disponível. Clique nos três pontos no canto superior direito para cancelar o pedido e reembolsar o cliente.',
        [BackendErrorCode.DeliveryProviderException]:
          'Infelizmente, a entrega tem de ser cancelada porque o estafeta não está disponível. Clique nos três pontos no canto superior direito para cancelar o pedido e reembolsar o cliente.',
        [BackendErrorCode.DeliveryDispatchRetrying]:
          'Encomenda aceite, mas ainda sem estafeta reservado. Continuamos a tentar durante 15 minutos e avisamos se não houver nenhum.',
      },
    },
  },
  error_messages: {
    something_went_wrong: 'Algo correu mal, tente novamente',
  },
};
